import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Eyebrow, SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="bg-ivory px-4 py-14 md:py-20" data-id="element-53" data-mp="1gauq77h1rshc">
      <div className="mx-auto max-w-3xl" data-id="element-54" data-mp="2dz4vbvc4qwco">
        <Eyebrow data-id="element-55" data-mp="2dy3hxk7n5xrs">What coaches usually ask</Eyebrow>
        <SectionTitle data-id="element-56" data-mp="292eh7djvyatw">Frequently asked questions</SectionTitle>
        <div className="mt-8 space-y-3" data-id="element-57" data-mp="24206fnqwgms6">
          {faqs.map(([question, answer], index) => <div key={question} className={`overflow-hidden rounded-2xl border bg-white transition-colors duration-150 ease-out ${open === index ? 'border-forest shadow-md' : 'border-charcoal/10'}`} data-id="element-58" data-mp="1z370qhhuu02k" data-mpi={index}>
              <button className="flex w-full items-center justify-between gap-3 p-5 text-left font-display text-sm font-extrabold uppercase text-charcoal md:text-base" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-id="element-59" data-mp="nn8ok4rdqxx4">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-forest transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-60" data-mp="fm4e96pbupxv" />
              </button>
              <AnimatePresence initial={false} data-id="element-61" data-mp="bhwpxams7c06">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={collapseTransition} className="border-t border-charcoal/10 px-5 py-4 text-sm leading-relaxed text-charcoal/80 md:text-base" data-id="element-62" data-mp="3syocsef0x72z">
                    {answer}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}